<template>
  <div v-if="!state.loading">
    <div class="pgehd" v-if="user.persona == 'Admin'">
        <h2>Test Manager</h2>
        <div class="pgectr">
            <span class="pgebtn" @click="createnew">
                Create Test
            </span>
        </div>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>

        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="name" header="Name" />
        <PrimeColumn field="academic_year" header="Academic Year" />
        <PrimeColumn field="semester" header="Semester" />
        <PrimeColumn field="type" header="Type" />
        <PrimeColumn header="Options">
            <template #body="slotProps">
                <div class="flex gap-2">
                    <PrimeButton
                        label="View Subjects"
                        icon="pi pi-bars"
                        class="p-button-rounded p-button-text"
                        @click="subjects(slotProps.data)"
                    />
                </div>
            </template>
        </PrimeColumn>
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
  
    <ModalView
        :isVisible="state.createModal"
        :fixclose="true"
        @close="state.createModal = false">
        <DynamicForm :columns="2"
            :fields="createFields" @submit="addTest"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref, computed} from 'vue';
import ModalView from "@/components/ModalView.vue";
import DynamicForm from "@/components/DynamicForm.vue";
import { useRouter } from "vue-router";
import { useStore } from 'vuex';

export default {
    name:"TestManager",
    components:{ModalView,DynamicForm},
    setup(){
        const store= useStore();
        const user = computed(() => store.state.User.user);
        const router = useRouter();
        const state=reactive({loading:true,createModal:false,
            submitting:false,error:[],success:false,type:[{label:"Midterm Exams",value:"1"},{label:"Final Examination",value:"2"}]
        })
        const list = ref([])
        const globalFilter=ref("")
        const createFields=ref([
            { name: "Create Test", number: "1",data: 
                    [
                        { type: 'text', name: 'name', label: 'Name',
                            value:"" },
                        {type:'select', name:"type", label:"Test type",
                            options:state.type
                        }
                    ]
                }
        ])

        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }

        onMounted(() => {
            call({
                url:urls.test,
                data:{getTests:""},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        setTable(res.msg.list)
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function createnew(){
            state.createModal=true;
            state.submitting=false;
            state.errors=[];
        }

        function subjects(row){
            router.push({ name: 'testsubjects', params: { id: row.id } });
        }

        function addTest(data){
            state.submitting=true;
            state.errors=[];
            data.addTest="";
            state.success=false;
            call({
                url:urls.test,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        router.push({ name: 'testsubjects', params: { id: res.msg } });
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }
        
        return {list,globalFilter, state,createFields,createnew,subjects,addTest,user}
    }
}
</script>